module.exports = "https://static.wmbcdn.com/uniweb/images/3e6c358aeaabcf2e84c9d3f52fc29f3f.svg";